import { c as _c } from "react/compiler-runtime";
import { DisplayTheme, DisplayThemeWithSDG, useDataDictionary } from '@netpurpose/api';
import { useLoggedIn } from '@netpurpose/core';
import { canAccessSDGThemeMetrics, mapQuestionsToThemes } from '#utils';
export const useThemeOptions = () => {
  const $ = _c(1);
  const {
    user
  } = useLoggedIn();
  const hasSDGRevenuePerms = canAccessSDGThemeMetrics(user);
  const themes = Object.values(hasSDGRevenuePerms ? DisplayThemeWithSDG : DisplayTheme);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: questions
  } = useDataDictionary(t0);
  const questionsForThemes = mapQuestionsToThemes(themes || [], questions || []);
  const availableThemes = (themes || []).filter(theme => questionsForThemes[theme].length > 0);
  return availableThemes.sort(_temp).map(_temp2);
};
function _temp(a, b) {
  return a.localeCompare(b);
}
function _temp2(theme_0) {
  return {
    label: theme_0,
    value: theme_0
  };
}